import { render, staticRenderFns } from "./DadRequest.vue?vue&type=template&id=b47aa530&scoped=true"
import script from "./DadRequest.vue?vue&type=script&lang=js"
export * from "./DadRequest.vue?vue&type=script&lang=js"
import style0 from "./DadRequest.vue?vue&type=style&index=0&id=b47aa530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47aa530",
  null
  
)

export default component.exports